import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { PPTAccountData } from 'egov-api';

export const addPPTAccountData = createSourcedAction('Add PPT Account data', props<{ accountsData: PPTAccountData[] }>());
